var _defs, _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMarkerComplete(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "309.01 570.92 149.95 224.14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#39b54a;}.cls-3{fill:#8cc63f;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "webapp-assets-set") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M384,570.94a74.93,74.93,0,0,0-72,95.89l72,128.23,64.67-111.25,7.3-17a74.93,74.93,0,0,0-72-95.89Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M447.65,645.9A63.65,63.65,0,0,0,384,582.24V772.57l54.9-94.44h0A63.28,63.28,0,0,0,447.65,645.9Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M320.35,645.9a63.28,63.28,0,0,0,8.77,32.23h0L384,772.57V582.24A63.65,63.65,0,0,0,320.35,645.9Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M423,645.9a39,39,0,1,1-39-39A39,39,0,0,1,423,645.9Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkerComplete);
export default __webpack_public_path__ + "static/media/marker-complete.8bd0e954a16047f81e565428e673ad2f.svg";
export { ForwardRef as ReactComponent };